import type { FacetLists, FacetRanges } from '~/contracts/common';

type FacetBooleanKeys = 'isFreeDelivery';
type FacetListKeys = keyof FacetLists | 'cvnaFeatureIds' | 'tagIds';
type FacetRangeKeys = keyof FacetRanges;

export const booleanFacets: FacetBooleanKeys[] = ['isFreeDelivery'];

export const rangeFacets: Array<FacetRangeKeys | 'finance'> = [
  'finance',
  'mileage',
  'mpg',
  'price',
  'seatingCapacity',
  'towingCapacity',
  'year'
];

export const listFacets: FacetListKeys[] = [
  'bodyStyles',
  'categoryIds',
  'colors',
  'cvnaFeatureIds',
  'cvnaFeatures',
  'cylinderCounts',
  'driveTypes',
  'features',
  'fuelTypes',
  'interiorColors',
  'sizeClasses',
  'tagIds',
  'transmissions',
  'truckCabTypes',
  'truckBedLengths'
];

// These facets resolve display names from a static map rather than API bucket data,
// so they are excluded from listFacets and handled separately.
export const staticDisplayNameFacets: FacetListKeys[] = [
  'luxuryTypes',
  'seatMaterials',
  'sportTypes'
];

export const facetsWithDisplayName: Array<FacetListKeys | 'isFreeDelivery'> = [
  'isFreeDelivery',
  ...listFacets
];
